import React from 'react';
import { cn } from '../../lib/cn';
import { Icon } from '../Icon/Icon';

const labelClass = 'mb-2 block text-[10px] font-bold uppercase tracking-[0.16em] text-[var(--ink-3)]';
const fieldClass = 'w-full rounded-[var(--r-sm)] border border-[var(--cream-2)] bg-[var(--cream-1)] px-4 py-[11px] text-sm text-[var(--ink-1)] outline-none transition focus:border-[var(--ai-4)] focus:shadow-[0_0_0_3px_rgba(91,141,239,0.15)]';

export type SelectOption = string | { value?: string; label?: React.ReactNode };
export interface SelectProps {
  label?: string;
  options: SelectOption[];
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  error?: string;
}

export function Select({ label, options, value, onChange, placeholder, error }: SelectProps) {
  const [open, setOpen] = React.useState(false);
  const getOptionValue = (option: SelectOption, index: number) => typeof option === 'string' ? option : option.value ?? `option-${String(index)}`;
  const current = options.find((option, index) => getOptionValue(option, index) === value) ?? options[0];
  const currentLabel = current ? (typeof current === 'string' ? current : current.label) : placeholder;
  return (
    <div className="relative">
      {label ? <label className={labelClass}>{label}</label> : null}
      <button onClick={() => { setOpen((next) => !next); }} className={cn(fieldClass, 'flex items-center justify-between text-left', error && 'border-[var(--terracotta)]')}>
        <span className={currentLabel ? undefined : 'text-[var(--ink-3)]'}>{currentLabel ?? placeholder}</span>
        <Icon kind="down" size={16} className="text-[var(--ink-3)]" />
      </button>
      {open ? (
        <div className="absolute left-0 right-0 top-[calc(100%+6px)] z-20 overflow-hidden rounded-[var(--r-md)] border border-[var(--cream-2)] bg-[var(--cream-1)] p-1.5 shadow-[var(--sh-3)]">
          {options.map((option, index) => {
            const item = typeof option === 'string' ? { value: option, label: option } : { value: getOptionValue(option, index), label: option.label };
            const active = item.value === value;
            return (
              <button key={item.value} onClick={() => { onChange?.(item.value); setOpen(false); }} className={cn('flex w-full items-center justify-between rounded-[var(--r-sm)] px-3 py-[9px] text-left text-[13.5px] text-[var(--ink-1)]', active && 'bg-[var(--cream-0)]')}>
                {item.label}
                {active ? <Icon kind="check" size={15} stroke={2.4} className="text-[var(--ai-3)]" /> : null}
              </button>
            );
          })}
        </div>
      ) : null}
      {error ? <div className="mt-1.5 text-[11.5px] text-[var(--terracotta)]">{error}</div> : null}
    </div>
  );
}
